<template>
  <div class="tabs-component">
    <ul
      role="tablist"
      class="tabs-component-tabs"
    >
      <li
        v-for="(tab, i) in tabs"
        v-show="tab.isVisible"
        :key="i"
        :class="{ 'is-active': tab.isActive, 'is-disabled': tab.isDisabled }"
        class="tabs-component-tab"
        role="presentation"
      >
        <router-link
          :aria-controls="tab.hash"
          :aria-selected="tab.isActive"
          :to="tab.hash"
          class="tabs-component-tab-a"
          role="tab"
          v-html="tab.header"
        />
      </li>
    </ul>
    <div class="tabs-component-panels">
      <slot />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    cacheLifetime: {
      default: 5
    },

    options: {
      type: Object,
      required: false,
      default: () => ({
        useUrlFragment: true
      })
    },

    parent: {
      type: String,
      default: ''
    }

  },

  data: () => ({
    tabs: [],
    activeTabHash: '',
    activeTab: '',
    firstTab: ''
  }),

  watch: {
    $route: function () {
      let section = this.$route.params[this.parent + '_section']
      if (this.active === section) {
        return false
      }
      if (this.active !== undefined) {
        this.tabs[this.active].isActive = false
      }
      if (this.tabs[section] !== undefined) {
        this.tabs[section].isActive = true
        this.active = section
      } else {
        this.firstTab.isActive = true
        this.active = this.firstTab.id
      }

      this.$emit('change', {'tab': this.active})

      return false
    }
  },

  mounted () {
    let tabs = {}
    let active = this.$route.params[this.parent + '_section']
    this.firstTab = this.$children[0]

    for (let i in this.$children) {
      if (this.$children[i].id === active) {
        this.$children[i].isActive = true
        this.active = active
      }
      tabs[this.$children[i].id] = this.$children[i]
    }
    this.tabs = tabs
  },
}
</script>
